<template>
  <div class="goods-out-block">
  	<a href="javascript:void(0)" class="goods-item-mask"></a>
  	<div class="select-opt" v-if="selecteable">
  		<check-item @clickItem="selectItem" :itemChecked="!!goodsData.isChecked"></check-item>
  	</div>
    <img class="goods-avatar" :src="goodsData.img_url" />
    <!--写死的商品图片-->
    <!--<img class="goods-avatar" src="../../assets/goods-avatar.jpg" />-->
    <div class="goods-info-box">
      <h3 class="goods-name">{{goodsData.cn_name}}</h3>
      <h3 class="goods-name">{{goodsData.en_name}}</h3>
      <p>
        <label class="goods-attr">项目号:<span>{{goodsData.code}}</span></label>
        <label class="goods-attr">CAS号:<span>{{goodsData.cas}}</span></label>
      </p>
      <p>
        <label class="goods-attr">浓度级别:<span>{{goodsData.level}}</span></label>
      </p>
			<p>
				<label v-if="goodsData.if_explode" class="goods-warning"><span>易制爆</span></label>
				<label v-if="goodsData.if_drag" class="goods-warning"><span>易制毒</span></label>
			</p>
    </div>

  </div>
</template>

<script>
  import CheckItem from 'basic/checkItem/checkItem'
	export default {
    name: 'searchIndex',
    data () {
      return {
      }
    },
    props:{
      goodsData:{
      	type:Object,
      	default () {
		      return {}
		    }
      },
      selecteable:{
      	type:Boolean,
      	default:false
      },
      index:{
      	type:Number,
      	default:0
      }
    },
    computed:{
    },
    methods:{
    	selectItem(){
    		this.$emit('selectItem',this.index);
    	}
    },
    components:{
        CheckItem
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
.goods-out-block{
	position:relative;
	padding: .1rem;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	.goods-item-mask{
		position:absolute;
		top:0;
		left:0;
		right:0;
		bottom:0;
		background-color: rgba(0,0,0,0);
		&:active{
		background-color: rgba(0,0,0,.2);
		}
	}
	.select-opt{
		position:relative;
		width: .2rem;
		z-index: 10;
	}
	.goods-avatar{
		width: .7rem;
		height:.65rem;
		border: 1px solid #eee;
	}
	.goods-info-box{
		padding-left: .1rem;
		font-size: .12rem;
		line-height: .18rem;
		color: #333;
		.goods-name{

		}
		p{
			.goods-attr{
				padding-right: .05rem;
				span{
				color:#0074D9;
				}
			}
			.goods-warning{
				padding-right: .05rem;
				span{
				color:#FF0000;
				}
			}
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/basic/goodsItem/goodsItem.vue